<div class="row page-header">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="mb-0">Business Plan Sections <small>Configure the available business plan sections</small></h1>
            @if (activeTab === 2) {
                <button class="btn btn-secondary btn-sm" (click)="printDocument()" title="Print Business Plan">
                    <fa-icon [icon]="faPrint"></fa-icon> Print
                </button>
            }
        </div>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Sections</a>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Preview</a>
        </li>
    </ul>
    <div style="margin-top: 10px">
        <div [hidden]="activeTab !== 1">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                                <action-toolbar-buttons
                                    [grid]="grid"
                                    [canEdit]="canEdit"
                                    [showAdd]="true"
                                    [addText]="'Add New'"
                                    [showEdit]="true"
                                    [showDelete]="true"
                                ></action-toolbar-buttons>
                                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <wj-flex-grid
                                id="mainGrid"
                                #mainGrid
                                appAutoSize
                                [minHeight]="70"
                                (initialized)="grid.initialize(mainGrid)"
                                (destroy)="grid.destroy()"
                                [itemsSource]="grid.view"
                                (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                            >
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <!-- <wj-flex-grid-column [header]="'Type'" [binding]="'sectionType'" [width]="75"></wj-flex-grid-column> -->
                                <wj-flex-grid-column [header]="'Heading'" [binding]="'heading'" [width]="'*'"></wj-flex-grid-column>
                                <!-- <wj-flex-grid-column [header]="'Theme'" [binding]="'theme'" [width]="150"></wj-flex-grid-column> -->
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6" appAutoSize [minHeight]="100">
                    @if (grid.selectedItem) {
                        <div class="h-100 d-flex flex-column">
                            <h4 style="margin-bottom: 12px; flex-shrink: 0">{{ grid.selectedItem?.heading }}</h4>
                            <div class="flex-grow-1" style="min-height: 0">
                                <quill-view
                                    style="display: block; height: 100%"
                                    [content]="grid.selectedItem?.content ?? 'No Content'"
                                    theme="snow"
                                ></quill-view>
                            </div>
                        </div>
                    } @else {
                        <div
                            class="d-flex align-items-center justify-content-center h-100"
                            [style.visibility]="isInitialLoading ? 'hidden' : 'visible'"
                        >
                            <div class="text-center">
                                <div class="mb-3">
                                    <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                                </div>
                                <h5 class="text-muted mb-2">No Section Selected</h5>
                                <p class="text-muted mb-0">Select a business plan section from the list to view its content</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        @if (activeTab === 2) {
            <app-business-plan-summary [sections]="grid.items" [canEdit]="canEdit"></app-business-plan-summary>
        }
    </div>
</div>
